import React, { Component } from "react";
import RootChangePassword from "container/account/changePassword/RootChangePassword";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getEssentialUrl } from "lib/urlQueryParser";

class ChangePasswordPage extends Component {
  render() {
    return (
      <AppUpdateCheckpoint>
        <GatewayCheckpoint
          type={"replace"}
          url={getEssentialUrl({ type: "opening" })()}
        >
          <RootChangePassword />
        </GatewayCheckpoint>
      </AppUpdateCheckpoint>
    );
  }
}

export default ChangePasswordPage;
